import 'uikit';
import * as loading from "loading.js";

$(function(){
	$("#searchGame").on('keyup',function(){
		var search = $(this).val();
		if( search.length > 3 ) {
			searchGame(search);
		}
	});

	$(document).on( 'submit', '.formPlayerInfos', function(event){
		event.preventDefault();

		let thisForm = $(this),
			theButton = thisForm.find( 'input[type=submit]' );

		theButton.prop( 'disabled', true );

		$.post( thisForm.attr('action'), thisForm.serialize() )
			.done(function( data ){
				if( data.result === 'success' ) {
					$('.uk-modal').hide();
					loading.showHide( $(this), true );
					window.location = data.redirect;
				} else {
					thisForm.find( '.message' ).text( data.message ).show( 150 );
					theButton.prop( 'disabled', false );
				}
			})
			.fail( function() {
				UIkit.modal.alert( $('#textContainer').data('error-five-hundred'), { center: true } ).on({
					'hide.uk.modal': function() {
						if( window.formGameModal ) {
							window.formGameModal.hide();
						}

						loading.showHide( $(this), true );
						window.location = rootURL + '/play/';
					}
				});
			} );

	});

	$(document).on( 'submit', '.publicBoardAccess', function(event){
		event.preventDefault();

		let thisForm = $(this),
			theButton = thisForm.find( 'input[type=submit]' );

		theButton.prop( 'disabled', true );

		$.post( $(this).attr('action'), $(this).serialize() )
			.done(function( data ){
				if( data.result === 'success' ) {
					$('.uk-modal').hide();
					loading.showHide( $(this), true );
					window.location = data.board;
				} else {
					thisForm.find( '.message' ).text( data.message ).show(150);
					theButton.prop( 'disabled', false );
				}
			})
			.fail( function() {
				UIkit.modal.alert( $('#textContainer').data('error-five-hundred'), { center: true } ).on({
					'hide.uk.modal': function() {
						if( window.formGameModal ) {
							window.formGameModal.hide();
						}

						loading.showHide( $(this), true );
						window.location = rootURL + '/play/';
					}
				});
			} );
	});

	if( $('body').hasClass('unsupported_browser_ie') ) {
		UIkit.modal.blockUI( unsupported_bowser_ie, { center: true } );
	}

	if( $('body').hasClass('unsupported_browser_ios') ) {
		UIkit.modal.blockUI( unsupported_bowser_ios, { center: true } );
	}

	window.gameTimer = setInterval(function(){
		searchGame();
	}, 5000);

	var nbRequest = 0;

	$('#gamesContainer').on('click', '.btnBoard', function(e){
		e.preventDefault();

		let theButton = $(this),
			boardLink = theButton.data('href'),
			idCaller = theButton.data('caller');
			alias = theButton.data('alias');

		theButton.prop( 'disabled', false );
		gotoBoardLink( alias, idCaller );
	});

	$('#gamesContainer').on('click', '.btnJoin', function(e){
		e.preventDefault();

		let theButton = $(this),
			gameLink = theButton.data('href'),
			bypass = theButton.hasClass('bypass'),
			idCaller = theButton.data('id-caller'),
			isPrivateGame = theButton.data('private');

		theButton.prop('disabled', true);

		if( typeof document.requestStorageAccess === "function" ) {
			var accept_cookie_promise = document.requestStorageAccess();
			let accept_cookie_notification = $('#textContainer').data('accept-cookie');

			accept_cookie_promise.then(
				function () {
					gotoGameLink( gameLink, isPrivateGame, idCaller, bypass );
					theButton.prop('disabled', false);
				}, function () {
					theButton.prop('disabled', false);
					explainWhyAccessIsNeeded( accept_cookie_notification );
				}
			);
		} else {
			theButton.prop('disabled', false);
			gotoGameLink( gameLink, isPrivateGame, idCaller, bypass );
		}
	});

});


// Functions

function searchGame( search, cpt ){
	if( search === undefined ) {
		search = $("#searchGame").val() || ' ';
	}

	let $gameContainer = $('#gamesContainer');

	fetch( rootURL + "webcardsapi/getListActivesGames/?" + $.param({
		name: search.trim(),
		start: cpt,
		curPage: curPage,
		private_listing: private_listing,
		csrf_tk_bingomaker: csrf_token
	}))
	.then(function(response){
		if( response.ok ) {
			return response.json();
		} else {
			console.log("erreur");
		}
	})
	.then(function(data){
		if( data.result !== undefined ) {
			switch ( data.result  ) {

				case "success":{
					$gameContainer.html('');
					let haveCardMsg = join;
					let cardsTxt = $('#textContainer').data('cardsTxt');

					for( var value of data.message ) {
						let login = '';
						if( value.haveCard === true ) {
							haveCardMsg = alreadyGame;
							login = 'haveActiveGame';
						}

						let boardLink = '';
						if( value.flashboard != false ) {
							boardLink = '<button data-alias="' + value.flashboard + '" data-caller="' + value.idCaller + '" class="btnBoard uk-button uk-margin-small uk-margin-left">' + $('#textContainer').data('board-txt') + '</button>';
						}

						// console.log( value.hasActiveGame+' === false && ( '+value.nbActives+' == '+value.nbCards+' || ( '+value.nbCards+' - '+value.nbActives+' < '+value.cardByPlayer+' ) || '+value.locked+' == 1 ) ');

						if( value.hasActiveGame === false && ( value.nbActives == value.nbCards || ( value.nbCards - value.nbActives < value.cardByPlayer ) || value.locked == 1 ) ) {
							$gameContainer.append(
								'<div class="gameContainer">' +
									'<div class="textLayout">' +
										'<div class="gameName">' +
											value.name + ' <small class="uk-text-small">(' + value.cardByPlayer + ' cards / player)</small>' +
										'</div>' +
										'<div class="gameInfo">' +
											'<strong>' + cardsTxt + '&nbsp;</strong>&nbsp;' +
											value.nbActives + ' / ' + ( value.useCodeList == false ? value.nbCards : value.totalCards ) +
											boardLink +
										'</div>' +
									'</div>' +
									'<div class="btnLayout">' +
										'<div class="btnFull full">' +
											$('#textContainer').data('game-full') +
										'</div>' +
									'</div>' +
								'</div>'
							);
						} else {
							$gameContainer.append(
								'<div class="gameContainer">' +
									'<div class="textLayout">' +
										'<div class="gameName">' +
											value.name + ' <small class="uk-text-small">(' + value.cardByPlayer + ' cards / player)</small>' +
										'</div>' +
										'<div class="gameInfo">' +
											'<strong>' + cardsTxt + '&nbsp;:</strong>&nbsp;' +
											value.nbActives + ' / ' + ( value.useCodeList == false ? value.nbCards : value.totalCards ) +
											boardLink +
										'</div>' +
									'</div>' +

									'<div class="btnLayout">' +
										'<a href="#" data-href="' + rootURL + 'card-interactive/interactive/' + value.idCaller + '/" class="' + login + ' btnJoin' + ( value.haveCard === true ? ' bypass' : '' ) + '" data-id-caller="' + value.idCaller + '" data-private="' + value.private + '">' +
											haveCardMsg +
										'</a>' +
									'</div>' +
								'</div>'
							);

						}

						haveCardMsg = join;
					}
				} break;

				case "empty":{
					$gameContainer.html('<div class="gameContainer"><div class="no-game"><strong>'+norecords+'</strong></div></div>');
				} break;

				case "noChange":
				break;

				default:{
					$gameContainer.html('<div class="gameContainer"><strong>ERROR</strong></div>');
				} break;
			}
		} else {
			window.location.reload();
		}
	})
	.catch(function(error){
		window.location.reload();
	});

}

function explainWhyAccessIsNeeded( modalText ) {
	UIkit.modal.alert( modalText, { center: true } ).on({
		'hide.uk.modal': function() {
			loading.showHide( $(this), true );
			window.location.reload();
		}
	});
}

function gotoBoardLink( alias, idCaller ) {
	let formContainer = $('#passwordToBoard'),
		formHTML;

	formContainer.find("input[name=idCaller]").val( idCaller );
	formContainer.find("input[name=alias]").val( alias );

	formHTML = formContainer.html();

	window.formGameModal = UIkit.modal.blockUI( formHTML, { center: true } );
}

function gotoGameLink( gameLink, isPrivateGame, idCaller, bypass ) {
	if( bypass === true ) {
		loading.showHide( $(this), true );
		window.location = gameLink;
	} else {
		let formContainer = $('#formPlayerInfos'),
			formHTML;

		formContainer.find("input[name=idCaller]").val(idCaller);

		formHTML = formContainer.html();

		window.formGameModal = UIkit.modal.blockUI( formHTML, { center: true } );
	}
}
